import fetchComponentData from './fetchComponentData'
import mapPageToTemplate from './mapPageToTemplate'
import memoizr from './memoizr'

export { fetchComponentData }
export { mapPageToTemplate }
export { memoizr }

export default {
  fetchComponentData,
  mapPageToTemplate,
  memoizr
}



// WEBPACK FOOTER //
// ./lib/index.js